.filter-top-bar .filter-wrapper{max-width:none}.filter-top-bar .filter-wrapper .dropdown-toggle.active{color:#5930fb;border-color:#5930fb}.filter-top-bar .filter-wrapper .dropdown-menu{min-width:300px}
/*# sourceMappingURL=scheduler-search.component-BPSFYBXZ.css.map */
